export const dateToStr = date => {
  const dateObj = new Date(date);
  const day = `${dateObj.getDate()}`;
  const month = `${dateObj.getMonth() + 1}`;
  return `${day.padStart(2, "0")}/${month.padStart(2, "0")}`;
};
